import React from 'react';

interface BannerImageProps {
    imgSrc: string,
    alt?: string
}

const BannerImageComponent: React.FC<BannerImageProps> = ({ imgSrc, alt }) => {

    return (
        <div className="pt-4 md:pt-6">
            <div className="relative h-64">
                <img
                    className="w-full h-full object-cover rounded-xl"
                    src={imgSrc}
                    alt={alt ? alt : ""}
                />
            </div>
        </div>
    )
};

export default BannerImageComponent;
